import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class HousingSituationService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/lease-housing-situations`, options);
  }
}

export default HousingSituationService;
